#import "../../../../../../../common/graphql/EntityDocumentsFields.graphql"
query AttachablePurchaseOrderDocuments(
  $first: Int
  $after: Cursor
  $purchaseOrderId: UUID!
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachablePurchaseOrderDocuments(
    first: $first
    after: $after
    purchaseOrderId: $purchaseOrderId
    orderBy: $orderBy
    filter: $filter
    documentTypeId: $documentTypeId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
